// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm icons:create to update
// Do not edit
import type { SVGProps } from 'react';

export const IconCloudUploadSvg = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.025 8.079a8.003 8.003 0 0 1 14.737 1.979A5.001 5.001 0 0 1 19 20H6a6 6 0 0 1-.975-11.921ZM12 6a6 6 0 0 0-5.428 3.438 1 1 0 0 1-.838.57A4 4 0 0 0 6 18h13a3 3 0 1 0-.053-6 1 1 0 0 1-1.008-.858A6.002 6.002 0 0 0 12 6Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 9a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.445 9.168a1 1 0 0 1 1.11 0l3 2a1 1 0 0 1-1.11 1.664L12 11.202l-2.445 1.63a1 1 0 0 1-1.11-1.664l3-2Z"
      clipRule="evenodd"
    />
  </svg>
);
